'use client';

import { type Unit, convertPace } from '@streetferret/geospatial/conversions';
import { formatPace } from '@streetferret/utils';
import { useUnitPreference } from '../unit-preference';
interface PaceProps {
  paceInSeconds: number;
}

export function Pace({ paceInSeconds }: PaceProps) {
  const { unit } = useUnitPreference();
  const toUnit = unit === 'imperial' ? 'miles' : 'kilometers';
  const unitNiceName = unit === 'imperial' ? 'mi' : 'km';
  const convertedSeconds = convertPace(paceInSeconds, 'meters', toUnit);
  const pace = formatPace(convertedSeconds);
  return (
    <div className="tabular-nums">
      <span>{pace}</span>
      <span>/</span>
      <span>{unitNiceName}</span>
    </div>
  );
}
